<!-- <ng-http-loader
  [entryComponent]="matSpinner"
  [filteredMethods]="['xhr']"
  [filteredUrlPatterns]="[
    'uploadDocument',
    'upload-profile-pic',
    'getReminderList'
  ]"
  [filteredHeaders]="['X-Skip-Loader']"
></ng-http-loader> -->
<myt-app-top-loader-bar></myt-app-top-loader-bar>
<myt-app-fullscreen-loader-overlay></myt-app-fullscreen-loader-overlay>
@if (isLoadingDebugEnabled) {
<myt-app-loading-debug-panel></myt-app-loading-debug-panel>
}
<mat-drawer-container
  class="home-page__wrapper"
  [class.home-page__wrapper--full-width]="useFullWidthContent"
  [hasBackdrop]="true"
>
  <mat-drawer #drawer [mode]="'over'" class="drawer-wrapper">
    <div class="w-fit ml-auto mt-4 mr-4">
      <button
        mat-mini-fab
        color="primary"
        aria-label="close"
        (click)="drawer.close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="p-6">
      @for (menuItem of toolbarMenuList; track $index) {
      @if(menuItem.isExpendable) {
      <mat-accordion multi class="my-2">
        <mat-expansion-panel [expanded]="menuItem.panelOpenState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="nav-item__icon accordian-icon" color="primary">{{
                menuItem.icon
              }}</mat-icon>
              <span>{{ menuItem.name }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list>
            @for (item of menuItem.expendableItems; track $index) {
            <mat-list-item
              matRipple
              class="nav-item shadow my-2 bg-white"
              (click)="
                item.active = true;
                setActiveNavItem($index, item);
                drawer.close()
              "
              [routerLinkActiveOptions]="myMatchOptions"
              [routerLink]="item.id"
              routerLinkActive="highlight-nav-item"
              [lines]="item.lines"
            >
              <mat-icon
                class="nav-item__icon"
                color="primary"
                matListItemAvatar
                >{{ item.icon }}</mat-icon
              >
              <span matListItemTitle>{{ item.name }}</span>
              {{ item.secondaryText }}
            </mat-list-item>
            }
          </mat-list>
        </mat-expansion-panel>
      </mat-accordion>

      } @else {
      <mat-list>
        <mat-list-item
          matRipple
          class="nav-item shadow bg-white"
          (click)="
            menuItem.active = true;
            setActiveNavItem($index, menuItem);
            drawer.close()
          "
          [routerLinkActiveOptions]="myMatchOptions"
          [routerLink]="menuItem.id"
          routerLinkActive="highlight-nav-item"
          [lines]="menuItem.lines"
        >
          <mat-icon class="nav-item__icon" color="primary" matListItemAvatar>{{
            menuItem.icon
          }}</mat-icon>
          <span matListItemTitle>{{ menuItem.name }}</span>
          {{ menuItem.secondaryText }}
        </mat-list-item>
      </mat-list>
      } }
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <mat-toolbar
      class="toolbar"
      [class.toolbar--overlay]="isHomeLanding && !isToolbarScrolled"
      [class.toolbar--solid]="!isHomeLanding || isToolbarScrolled"
    >
      <mat-toolbar-row>
        <div class="logo-container" [routerLink]="'/'" [class.logo-container--overlay]="isHomeLanding && !isToolbarScrolled"
      [class.logo-container--solid]="!isHomeLanding || isToolbarScrolled">
          <img
            src="https://myt-website-public-data-prod.s3.ap-south-1.amazonaws.com/website assets/mind-your-tax/images/logo.svg"
            alt="Mind Your Tax Logo"
          />
        </div>

        <div class="toolbar-wrapper">
          <div class="toolbar-items__wrapper">
            <ng-container
              *ngIf="tokenStorageService.userProfile | async as user"
            >
              @if (user.userId > 0) {
              <button mat-button class="menu-button" (click)="goToDashboard()">
                Dashboard
              </button>
              }
            </ng-container>
            <a [routerLink]="'/'">
              <button mat-button class="menu-button">Home</button>
            </a>
            <a [routerLink]="['/calculators', 'tax-calculator']">
              <button mat-button class="menu-button">Tax Calculator</button>
            </a>
            <button mat-button [matMenuTriggerFor]="services" class="menu-button">
              Services
              <mat-icon fontIcon="expand_more" iconPositionEnd></mat-icon>
            </button>
            <a [routerLink]="'/blogs'">
              <button mat-button class="menu-button">Blogs</button>
            </a>
            <a [routerLink]="'/about-us'">
              <button mat-button class="menu-button">About Us</button>
            </a>
            @if (authToolbarReady) {
            <ng-container
              *ngIf="tokenStorageService.userProfile | async as user"
            >
              @if (hasAuthenticatedUser(user)) {
              <span class="toolbar-actions__link">
                <button
                  mat-button
                  [matMenuTriggerFor]="profileMenu"
                  class="menu-button menu-button--outline"
                >
                  My Account
                  <mat-icon fontIcon="expand_more" iconPositionEnd></mat-icon>
                </button>
              </span>
              } @else {
              <a routerLink="/login" class="toolbar-actions__link">
                <button
                  mat-stroked-button
                  class="menu-button menu-button--outline"
                  aria-label="Sign in"
                >
                  Sign In
                </button>
              </a>
              }
            </ng-container>
            }
          </div>
          <div class="burger-icon__wrapper">
            @if (authToolbarReady) {
            <ng-container
              *ngIf="tokenStorageService.userProfile | async as user"
            >
              @if (hasAuthenticatedUser(user)) {
              <button
                mat-mini-fab
                color="primary"
                aria-label="My Profile"
                [matMenuTriggerFor]="profileMenu"
                class="menu-button sm:mr-2 md:mr-4 mr-2"
              >
                <mat-icon>account_circle</mat-icon>
              </button>
              <button
                [matMenuTriggerFor]="notifications"
                mat-mini-fab
                aria-label="notifications"
                color="primary"
              >
                <mat-icon matBadge="15">notifications</mat-icon>
              </button>
              } @else {
              <a routerLink="/login">
                <button mat-icon-button class="" aria-label="Login">
                  <mat-icon>login</mat-icon>
                </button>
              </a>
              }
            </ng-container>
            }
            <button
              mat-icon-button
              class="burger-icon"
              aria-label="Menu"
              (click)="drawer.open()"
            >
              <mat-icon>menu</mat-icon>
            </button>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <div
      class="content-wrapper"
      [class.content-wrapper--full-width]="useFullWidthContent"
      [class.content-wrapper--landing]="isHomeLanding"
    >
      <router-outlet></router-outlet>
      <div
        *ngIf="showFloatingIcons"
        class="floating-icons fixed flex flex-col items-center justify-center right-0 shadow-lg rounded-l-lg cursor-pointer bg-opacity-90"
      >
        <a [href]="whatsappCtaHref" target="_blank" rel="noopener noreferrer">
          <ng-lottie [options]="whatsappOptions" width="60px" height="60px" />
        </a>
        <a href="tel:+918521015658">
          <ng-lottie [options]="callOptions" width="60px" height="60px" />
        </a>
      </div>
      @if (!useFullWidthContent) {
        <br />
      }
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<div class="footer" *ngIf="!hideFooter">
  <myt-footer></myt-footer>
  <div class="footer__bottom @container">
    <div class="footer__brand-line">
      MIND YOUR TAX IS A BRAND OF NAYAME TAXACCORD FINSUPPORTS LLP
    </div>
    <div class="footer__policy-links">
      <a
        href="https://mindyourtax.in/policies/privacy-policy/"
        target="_blank"
      >
        Privacy Policy
      </a>
      <a
        href="https://mindyourtax.in/policies/terms-and-conditions/"
        target="_blank"
      >
        Terms & Conditions
      </a>
      <a href="https://mindyourtax.in/policies/refund/" target="_blank">
        Refund Policy
      </a>
      <a
        href="https://mindyourtax.in/policies/terms-conditions/"
        target="_blank"
      >
        Terms & Conditions for Payments
      </a>
    </div>
  </div>
</div>
<mat-menu #resources="matMenu">
  <button mat-menu-item>Tax Calculator</button>
  <mat-divider></mat-divider>
  <button mat-menu-item>Blog</button>
  <mat-divider></mat-divider>
</mat-menu>
<mat-menu #services="matMenu" xPosition="before">
  <myt-services-card
    [individualNavItems]="individualNavItems"
    [businessNavItems]="businessNavItems"
  ></myt-services-card>
</mat-menu>
<mat-menu #notifications="matMenu" xPosition="before">
  <ng-container *ngIf="tokenStorageService.userProfile | async as user">
    @if (user.role === 'REVIEWER' || user.role === 'ASSIGNEE' || user.role === 'TELECALLER'||user.role === 'ADMIN' ) {
    <myt-notifications-list></myt-notifications-list>
    }
  </ng-container>
</mat-menu>
<mat-menu #profileMenu="matMenu" xPosition="before">
  <a [routerLink]="['user', 'profile']">
    <button mat-menu-item>Profile</button></a
  >
  <mat-divider></mat-divider>
  <a [routerLink]="['user', 'orders']">
    <button mat-menu-item>My Orders</button>
  </a>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="signout()">Logout</button>
</mat-menu>
<mat-menu #salaried="matMenu">
  <button
    mat-menu-item
    (click)="scrollIntoView('nil-return', ['packages', 'details'])"
  >
    Below 5 Lakh/Annum
  </button>
  <mat-divider></mat-divider>
  <button
    mat-menu-item
    (click)="scrollIntoView('salary-upto-50lacs', ['packages', 'details'])"
  >
    Below 50 Lakh/Annum
  </button>
  <mat-divider></mat-divider>
  <button
    mat-menu-item
    (click)="scrollIntoView('salary-above-50lacs', ['packages', 'details'])"
  >
    Above 50 Lakh/Annum
  </button>
  <mat-divider></mat-divider>
  <button
    mat-menu-item
    (click)="
      scrollIntoView('salary-plus-capital-gain', ['packages', 'details'])
    "
  >
    Capital Gain Income
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="viewId = 'OTHER'; openContactForm()">
    Not sure? Contact Us!
  </button>
</mat-menu>

<mat-menu #business="matMenu">
  <button mat-menu-item (click)="scrollIntoView('PERSONAL_ITR', ['packages'])">
    Firm
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="scrollIntoView('PERSONAL_ITR', ['packages'])">
    Trust
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="viewId = 'OTHER'; openContactForm()">
    Not sure? Contact Us!
  </button>
</mat-menu>
<mat-menu #company="matMenu">
  <a [routerLink]="['contact-us']">
    <button mat-menu-item>Contact Us</button>
  </a>
  <mat-divider></mat-divider>
  <a [routerLink]="['about-us']">
    <button mat-menu-item>About Us</button>
  </a>
</mat-menu>
